var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrangeTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3712",
    "data-name": "Rectangle 3712",
    width: 20,
    height: 20,
    transform: "translate(4.291 4.291)",
    fill: "#ed8b00",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5013",
    "data-name": "Group 5013",
    transform: "translate(-4.291 -4.291)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_629",
    "data-name": "Mask Group 629",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "twitter",
    d: "M17.944,5.926c.013.178.013.355.013.533A11.583,11.583,0,0,1,6.294,18.122,11.583,11.583,0,0,1,0,16.282a8.48,8.48,0,0,0,.99.051,8.209,8.209,0,0,0,5.089-1.751,4.106,4.106,0,0,1-3.833-2.843,5.169,5.169,0,0,0,.774.063,4.335,4.335,0,0,0,1.079-.14A4.1,4.1,0,0,1,.812,7.64V7.589a4.128,4.128,0,0,0,1.853.52A4.105,4.105,0,0,1,1.4,2.627,11.651,11.651,0,0,0,9.848,6.916a4.627,4.627,0,0,1-.1-.939,4.1,4.1,0,0,1,7.094-2.8,8.07,8.07,0,0,0,2.6-.99,4.088,4.088,0,0,1-1.8,2.259A8.217,8.217,0,0,0,20,3.807a8.811,8.811,0,0,1-2.056,2.119Z",
    transform: "translate(4.291 4.291)",
    fill: "#ed8b00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeTwitter);
export default __webpack_public_path__ + "static/media/orange-twitter.5b4aab53bc36380eb15acedbd23b8c3a.svg";
export { ForwardRef as ReactComponent };